// @flow
import { useHistory, useParams } from 'react-router-dom';
import React from 'react';
import { useDeleteStreamGovernanceResourceMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { getDeleteWithWarningHeaderAndBody } from '@src/common-utils/utils';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { getLinkForOrganizationsPage } from '@streaming-projects/links';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';

export const SPStreamGovernanceResourceDeleteWarningModal = ({
  isOpen,
  onClose,
  streamGovernanceResourceName,
  streamGovernanceResourceId,
  version = null,
}) => {
  const [deleteStreamGovernanceResource] = useDeleteStreamGovernanceResourceMutation();
  const { orgId } = useParams();
  const { push } = useHistory();
  const { header, headerBody } = getDeleteWithWarningHeaderAndBody(
    'SG Resource',
    streamGovernanceResourceName
  );

  const onClickHandlerForOK = async () => {
    const { error } = await deleteStreamGovernanceResource({
      streamGovernanceResourceId: streamGovernanceResourceId,
      orgId: orgId,
      payload: {
        version: version,
      },
    });
    if (error) {
      toastError(error);
    } else {
      toastSuccess('Stream Governance Resource delete was successful!');
      push(getLinkForOrganizationsPage(orgId));
    }
  };

  return (
    <ConfirmModal
      body={headerBody}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={onClose}
      onClickHandlerForOK={onClickHandlerForOK}
    />
  );
};
